import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PlaceSetDescription } from 'app/actions/Place/place.action';
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from 'draft-js';
import 'draft-js/dist/Draft.css';
import withTranslations from 'app/components/HOGs/withTranslations';
import draftToHtml from 'draftjs-to-html';
import parse from 'html-react-parser';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const toolbar = {
  options: ['inline', 'textAlign', 'history', 'list', 'link', 'remove'],
  inline: {
    inDropdown: false,
    className: 'inline',
    component: undefined,
    dropdownClassName: undefined,
    options: ['bold', 'italic', 'underline'],
  },
  textAlign: {
    inDropdown: false,
    className: 'textAlign',
    component: undefined,
    dropdownClassName: undefined,
    options: ['left', 'center', 'right', 'justify'],
  },
  history: {
    inDropdown: false,
    className: 'history',
    component: undefined,
    dropdownClassName: undefined,
    options: ['undo', 'redo'],
  },
  list: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ['unordered', 'ordered'],
  },
  link: {
    inDropdown: false,
    className: 'link',
    component: undefined,
    popupClassName: undefined,
    dropdownClassName: undefined,
    showOpenOptionOnHover: true,
    defaultTargetOption: '_self',
    options: ['link'],
    linkCallback: undefined,
  },
  remove: { className: undefined, component: undefined },
};

const editorLabels = {
  // History
  'components.controls.history.history': 'History',
  'components.controls.history.undo': 'Undo',
  'components.controls.history.redo': 'Redo',

  // Inline
  'components.controls.inline.bold': 'Bold',
  'components.controls.inline.italic': 'Italic',
  'components.controls.inline.underline': 'Underline',

  // Link

  'components.controls.link.link': 'Link',

  // List
  'components.controls.list.list': 'List',
  'components.controls.list.unordered': 'Unordered',
  'components.controls.list.ordered': 'Ordered',

  // Remove
  'components.controls.remove.remove': 'Remove',

  // TextAlign
  'components.controls.textalign.textalign': 'Text Align',
  'components.controls.textalign.left': 'Left',
  'components.controls.textalign.center': 'Center',
  'components.controls.textalign.right': 'Right',
  'components.controls.textalign.justify': 'Justify',
};

let delyChangeDescription = null;
let first = true;

class PlaceDescription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
    };
    this.ref = React.createRef();
  }

  setEditorState = (editorState) => {
    this.setState({
      editorState,
    });
  };

  saveToRedux = () => {
    const { editorState } = this.state;
    const { PlaceSetDescription, activeMultiPart } = this.props;
    const data = draftToHtml(convertToRaw(editorState.getCurrentContent()));

    if (delyChangeDescription) clearTimeout(delyChangeDescription);

    delyChangeDescription = setTimeout(() => {
      if (editorState.getCurrentContent()) {
        const tourData = { ...activeMultiPart };
        tourData.description = data;
        if (this.checkDesc(data)) {
          PlaceSetDescription(data);
        }
      }
    }, 1200);
  };

  componentWillUnmount() {
    first = true;
  }

  componentDidUpdate(prevProps, prevState) {
    const { activeMultiPart = {} } = this.props;
    if (
      (prevProps.activeMultiPart.description !== activeMultiPart.description &&
        first) ||
      (prevProps.activeMultiPart.description !== activeMultiPart.description &&
        activeMultiPart.description === '')
    ) {
      first = false;
      const blocksFromHTML = convertFromHTML(
        activeMultiPart.description ? activeMultiPart.description : ' '
      );
      const { contentBlocks, entityMap } = blocksFromHTML;
      const contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      );
      const editorState = contentState.getBlockMap().size
        ? EditorState.createWithContent(contentState)
        : EditorState.createEmpty();

      this.setEditorState(editorState);
    }

    if (
      prevState.editorState !== this.state.editorState &&
      this.props.isEditMode
    ) {
      this.saveToRedux();
    }
  }

  getDesc = () => {
    const { description } = this.props.activeMultiPart;
    return description;
  };

  onFocus = () => {
    this.ref.current.classList.add('on_focus');
  };

  onBlur = () => {
    this.ref.current.classList.remove('on_focus');
  };

  checkDesc = (desc) => desc && desc !== '<p></p>' && desc !== '<p></p>\n';

  render() {
    const { editorState } = this.state;
    const { isEditMode, tr } = this.props;

    let className = 'text_editor';
    const contentState = editorState.getCurrentContent();

    if (!contentState.hasText()) {
      if (contentState.getBlockMap().first().getType() !== 'unstyled') {
        className += ' text_editor-hidePlaceholder';
      }
    }

    return (
      <div className={className} ref={this.ref}>
        {isEditMode ? (
          <Editor
            editorState={editorState}
            onEditorStateChange={this.setEditorState}
            placeholder={tr['Description of the Place']}
            toolbar={toolbar}
            localization={{ locale: 'en', translations: editorLabels }}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
          />
        ) : (
          <div className="view_desc">
            {this.checkDesc(this.getDesc())
              ? parse(this.getDesc())
              : tr['Description of the Place']}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    activeMultiPart: store.placesData.data,
    isEditMode: store.placesData.isEditMode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ PlaceSetDescription }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslations(PlaceDescription));
